import { render, staticRenderFns } from "./GraphsKamsSupports.vue?vue&type=template&id=feedfa20"
import script from "./GraphsKamsSupports.vue?vue&type=script&lang=js"
export * from "./GraphsKamsSupports.vue?vue&type=script&lang=js"
import style0 from "./GraphsKamsSupports.vue?vue&type=style&index=0&id=feedfa20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports